export default {
    SUPER_ADMIN: 'Super Admin',

    // user can be normal, corporate and corporate with physiotherapy theme type.
    USER: 'Enduser',
    ADMIN: 'CorporateHR',

    TRAINER: 'Trainer',
    TRAINER_ADMIN: "Admin",
    VIDEO_MANAGER: 'Video Manager'
}